export default __webpack_public_path__ + "static/media/hungary.0b7d3966.svg";